
export default {
  password: {pattern:'^(?=.*\\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$', message: '密码需要包含数字及字母且8-20个字符', trigger: 'change'},
  phone: {pattern:/^1[0-9]{10}$/, message: '请输入正确的手机号', trigger: 'change'},
  idCard: {pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'change'},
  money:  { pattern: /(^[1-9]([0-9]{1,7})?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确格式,可保留两位小数,最大值为99999999.99' },
}

export const reg_phone_format=/(\d{3})\d{4}(\d{4})/
export const reg_phone=/^1[0-9]{10}$/
export const reg_password=/^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$/
